var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramfilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.143 20.4342C24.143 18.2724 22.3761 16.5134 20.2045 16.5134C18.0331 16.5134 16.2663 18.2725 16.2663 20.4342C16.2663 22.5965 18.0331 24.3552 20.2045 24.3552C22.3761 24.3552 24.143 22.5965 24.143 20.4342ZM29.9942 0.0241089H10.0057C4.49861 0.0241089 0.0182495 4.48499 0.0182495 9.96799V12.7386H14.7148C16.2655 11.6388 18.1595 10.9891 20.2045 10.9891C22.2494 10.9891 24.1437 11.6388 25.6945 12.7386H39.9816V9.96799C39.9816 4.48495 35.5012 0.0241089 29.9942 0.0241089ZM34.039 9.48151C34.039 10.0891 33.5398 10.5864 32.9293 10.5864H29.5005C28.8901 10.5864 28.3908 10.0891 28.3908 9.48151V6.06743C28.3908 5.45983 28.89 4.96255 29.5005 4.96255H32.9293C33.5398 4.96255 34.039 5.45975 34.039 6.06743V9.48151ZM29.6915 20.4342C29.6915 25.6428 25.4354 29.8795 20.2044 29.8795C14.9733 29.8795 10.7176 25.6428 10.7176 20.4342C10.7176 19.0003 11.042 17.6404 11.6189 16.4215H0.0182495V30.032C0.0182495 35.5154 4.49861 39.9759 10.0057 39.9759H29.9942C35.5013 39.9759 39.9816 35.5153 39.9816 30.032V16.4215H28.7902C29.3671 17.6404 29.6915 19.0003 29.6915 20.4342Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramfilled);
export default __webpack_public_path__ + "static/media/instagramfilled.ca752159ea6574fce37b96d8885ef7cc.svg";
export { ForwardRef as ReactComponent };